import { Component, OnInit } from '@angular/core';
import { OccurenceComments } from '@app/occurences/add-occurence-modal/occurence-list-comments/occurence-comments.interface';
import { Input } from '@angular/core';

@Component({
  selector: 'app-occurrence-comment-read-by',
  templateUrl: './occurrence-comment-read-by.component.html',
  styleUrls: ['./occurrence-comment-read-by.component.css']
})
export class OccurrenceCommentReadByComponent implements OnInit {

  @Input() comment: OccurenceComments;

  constructor() { }

  ngOnInit() {
  }

}
